import { inject } from '@angular/core';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { CampaignConfig, QuotaConfig, SenderTypeFromPartnerId } from '@galaxy/campaign/dependencies';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfigService } from '../app-config.service';
import { PartnerService } from '../core/partner.service';

export const CampaignConfigFactory = () => {
  const partner = inject(PartnerService) as PartnerService;
  const appCfg = inject(AppConfigService) as AppConfigService;
  const cfg: CampaignConfig = {
    sender$: SenderTypeFromPartnerId(partner.getPartnerId()),
    userId$: appCfg.config$.pipe(map((c) => c.unifiedUserId)),
    basePath$: of('campaigns'),
    location$: of('US', 'CA'),
    productBasePath$: of('store/app'),
  };
  return cfg;
};
export const CampaignQuotaConfigFactory = () => {
  const partner = inject(PartnerService) as PartnerService;
  const cfg: QuotaConfig = {
    sender$: SenderTypeFromPartnerId(partner.getPartnerId()),
    actionURL: '/upgrade',
  };
  return cfg;
};
